import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__MUOKD","gwcskeleton":"styles_gwcskeleton__48kmG","s":"styles_s__IOFEv","m":"styles_m__iOZX+","l":"styles_l__70HbO","xl":"styles_xl__YJO+9","squircle":"styles_squircle__wK-Z9","circle":"styles_circle__pE78w"};
export const b = b_.with('skeleton');